import { render, staticRenderFns } from "./kefudan.vue?vue&type=template&id=50ce9fba&scoped=true&"
import script from "./kefudan.vue?vue&type=script&lang=js&"
export * from "./kefudan.vue?vue&type=script&lang=js&"
import style0 from "./kefudan.vue?vue&type=style&index=0&id=50ce9fba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ce9fba",
  null
  
)

export default component.exports